import Reviews from './reviews'
import Product from './product';
import InstagramItemNewTab from './Component/InstagramItemNewTab';
import FacebookItemNewTab from './Component/FacebookItemNewTab';
import YoutubeItemNewTab from './Component/YoutubeItemNewTab';


const reviewsConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: 'views',
      element: <Product />,
    },
    {
      path: 'fb-post',
      element: <FacebookItemNewTab />,
    },
    {
      path: 'instagram-post',
      element: <InstagramItemNewTab />,
    },
    {
      path: 'youtube-post',
      element: <YoutubeItemNewTab />,
    },
  ],
};

export default reviewsConfig;
